import "./Project.scss";

const Project = ({ backgroundImage, targetUrl, title, content, skills }) => {
  const handleClick = () => {
    window.open(targetUrl, "_blank");
  };

  return (
    <div className="project" onClick={handleClick}>
      <div
        className="project__image"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <div className="project__overlay">
          <h3 className="project__title">{title}</h3>
          <p className="project__content">{content}</p>
          <p className="project__skills">{skills}</p>
        </div>
      </div>
    </div>
  );
};

export default Project;
